module.exports = __webpack_public_path__ + "static/img/Lark20220424-180000.a9d2d87c.png";